module.exports = __webpack_public_path__ + "static/media/notifications_blue.8951dc20.svg";